import styles from "./greenup-colors.module.scss"

export type GreenUpColor = "greenup-blue" | "crimson-red" | "greenup-green" | "dark-grey" | "grey" | "greenup-dark-blue"

const ColorMapping: { [c in GreenUpColor]: string } = {
  "greenup-green": styles.GreenUpGreen,
  "crimson-red": styles.CrimsonRed,
  "greenup-dark-blue": styles.GreenUpDarkBlue,
  "greenup-blue": styles.GreenUpBlue,
  "dark-grey": styles.DarkGrey,
  "grey": styles.Grey
}

export function mapGreenUpColorToCssClass(color: GreenUpColor): string {
  return ColorMapping[color]
}
